import React from "react";
import { Column } from "@ant-design/plots";
import styled from "@emotion/styled";
import { isNaN, map, max } from "lodash";
import { useTranslation } from "react-i18next";

const StyledTitle = styled.div`
  font-size: 0.9rem;
  font-weight: bold;
  color: #141414;
  margin-bottom: 10px;
  text-transform: uppercase;
`;

const StyledChartContainer = styled.div`
  border: solid 1px #9b9b9b;
  border-radius: 3px;
  padding: 10px;
  margin-bottom: 25px;
  .name-title {
    padding: 3px 10px;
    font-size: 1rem;
    padding-bottom: 15px;
  }
`;

function EmployeesPerDepartment({ report }) {
  const { t } = useTranslation();

  const config = {
    padding: "auto",
    data: report,
    height: 300,
    xField: "departmentname",
    yField: "users",
    seriesField: "departmentname",
    label: {
      position: "middle",
      content: "",
    },
    legend: false,
    columnStyle: {
      cursor: "pointer",
    },
    theme: {
      colors10: [
        "#0F1C73",
        "#1A449F",
        "#2B67BA",
        "#3C88C0",
        "#4BA7B3",
        "#5AC39B",
        "#6ADD7F",
        "#A8DD6A",
        "#DDDD6A",
      ],
      maxColumnWidth: 50,
      minColumnWidth: 50,
    },
    xAxis: {
      label: {
        formatter: (value) => value.slice(0, 3),
        offset: 10,
        autoHide: false,
        autoRotate: true,
      },
    },
    yAxis: {
      // max: isNaN(max(map(report, 'users'))) ? 100 : max(map(report, 'users')) + 15,
      grid: {
        line: {
          style: {
            opacity: 0,
          },
        },
      },
    },
  };

  return (
    <>
      <StyledTitle>{t("Number Of Users Per Department")}</StyledTitle>
      <StyledChartContainer>
        <Column {...config} />
      </StyledChartContainer>
    </>
  );
}

export default EmployeesPerDepartment;
